var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('user-create',{attrs:{"user-update":_vm.userUpdate,"title":_vm.$t('users_management.page_title.update'),"button-text":_vm.$t('users_management.buttons.update_user')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }